<template>
  <v-dialog
    persistent
    max-width="720"
    v-model="dialog"
  >
    <v-card v-if="status === 'loading'">
      <v-card-text>
        <div class="dialog__content py-5">
          <h4 class="dialog__title text-xs-center pb-5">{{ $t(`${namespace}.waitAfewMoments`) }}</h4>
          <transition name="fade">
            <div
              class="text-xs-center py-4"
            >
              <v-progress-circular :size="60" indeterminate color="success" />
            </div>
          </transition>
        </div>
      </v-card-text>
    </v-card>

    <v-card v-if="status === 'error'">
      <div class="dialog__header"></div>

      <v-card-text class="pt-3 px-5 pb-4">
        <div class="dialog__content">
          <h4 class="dialog__title pb-2">{{ $t(`${namespace}.transactionDeniedTitle`) }}</h4>
          <p>{{ $t(`${namespace}.transactionDeniedMessage`) }}</p>

          <div class="text-xs-center">
            <div>
              <v-btn
                type="submit"
                round
                color="accent"
                depressed
                large
                @click="closeDialog"
              >
                {{ $t(`${namespace}.changeCreditCard`) }}
              </v-btn>
            </div>

            <div class="mt-3">
              <a
                href="#"
                class="text--normal accent--text"
                color="accent"
                flat
                round
                @click.prevent="closeDialog"
              >
                {{ $t('Common.cancel') }}
              </a>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ChangePaymentMethodDialog',
  props: {
    dialog: {
      type: Boolean
    },
    status: {
      type: String
    }
  },
  data () {
    return {
      namespace: 'Components.FinancialDialog'
    }
  },
  methods: {
    closeDialog () {
      this.$emit('closeDialog')
    },

    closeDrawer () {
      this.$emit('closeDrawer')
    }
  },
  watch: {
    status (to, from) {
      if (from === 'success') {
        this.closeDrawer()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog__header {
  background-image: linear-gradient(108deg, #ffdd00, #ffb400);
  height: 280px;
  position: relative;

  &:before {
    background: url('~@/assets/img/img-credit-card-error.svg') no-repeat center;
    bottom: 0;
    content: "";
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
}

.dialog__title {
  font-size: 24px;
  font-weight: normal;
}
</style>
